import { useActionState } from "react";
import { updateSkillAction } from "@/actions/skills";
import { Button } from "@/components/Button";
import { FormCell, StaticCell } from "@/components/FormCell";
import styles from "@/components/FormRow.module.css";
import { LinkButton } from "@/components/LinkButton";
import { initialFormState } from "@/lib/formState";
import { useFormRedirect } from "@/lib/useFormRedirect";

const FORM_ID = "skill-edit";

type SkillEditRowProps = {
  // The listing owns the rows, so a save has to tell it to read again.
  onSaved: () => void;
  id: number;
  code: string;
  label: string | null;
  description: string | null;
  icon: string | null;
  color: string | null;
};

export const SkillEditRow = ({
 onSaved,
  id,
  code,
  label,
  description,
  icon,
  color,
}: SkillEditRowProps) => {
  const [state, formAction, isPending] = useActionState(
    updateSkillAction.bind(null, id),
    initialFormState,
  );

  useFormRedirect(state, onSaved);

  return (
    <>
      <StaticCell value={code} isRowHeader />
      <FormCell
        form={FORM_ID}
        name="label"
        label="Label"
        defaultValue={state.values.label ?? label ?? ""}
        errors={state.fieldErrors.label}
      />
      <FormCell
        form={FORM_ID}
        name="description"
        label="Description"
        defaultValue={state.values.description ?? description ?? ""}
        errors={state.fieldErrors.description}
      />
      <FormCell
        form={FORM_ID}
        name="icon"
        label="Icon"
        defaultValue={state.values.icon ?? icon ?? ""}
        errors={state.fieldErrors.icon}
      />
      <FormCell
        form={FORM_ID}
        name="color"
        label="Color"
        defaultValue={state.values.color ?? color ?? ""}
        errors={state.fieldErrors.color}
      />
      {/* Status, Created and the actions column: read-only while editing. */}
      <td className={styles.actions} colSpan={3}>
        {/* A form may not be a child of tbody, but it may sit inside a cell —
            the inputs above associate to it by id. */}
        <form id={FORM_ID} action={formAction} hidden />
        <Button
          type="submit"
          form={FORM_ID}
          variant="primary"
          disabled={isPending}
        >
          {isPending ? "Saving..." : "Save"}
        </Button>
        <LinkButton href="/skills" variant="secondary" shouldReplaceHistory>
          Cancel
        </LinkButton>
      </td>
    </>
  );
};
